import axios from 'axios'
import env from '../constants/env'
import authTokenStore from '../auth/tokenStore'

let isRefreshing = false
let refreshQueue = []

const subscribe = (cb) => {
  refreshQueue.push(cb)
}

const notify = (token) => {
  refreshQueue.forEach((cb) => cb(token))
  refreshQueue = []
}

const apiClient = axios.create({
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  baseURL: `${env.API_HOST}/api`,
})

apiClient.interceptors.request.use((config) => {
  const token = authTokenStore.get()
  if (!token) return config

  return {
    ...config,
    headers: {
      ...(config.headers ?? {}),
      Authorization: `Bearer ${token}`,
    },
  }
})

apiClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { response, config } = error

    if (!response || response.status !== 401 || config?._retry) {
      return Promise.reject(error)
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        subscribe((token) => {
          if (!token) {
            reject(error)
            return
          }

          resolve(
            apiClient({
              ...config,
              headers: {
                ...(config.headers ?? {}),
                Authorization: `Bearer ${token}`,
              },
              _retry: true,
            }),
          )
        })
      })
    }

    isRefreshing = true

    try {
      const refreshRes = await apiClient.post(
        '/v1/auth/refresh',
        {},
        { headers: { Authorization: undefined } },
      )

      const newToken = refreshRes.data.accessToken
      authTokenStore.set(newToken)
      notify(newToken)

      return await apiClient({
        ...config,
        headers: {
          ...(config.headers ?? {}),
          Authorization: `Bearer ${newToken}`,
        },
        _retry: true,
      })
    } catch (e) {
      authTokenStore.clear()
      notify(null)
      return await Promise.reject(e)
    } finally {
      isRefreshing = false
    }
  },
)

export default apiClient
